import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Feedback = () => {
  const [feedback, setFeedback] = useState('');
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (!user.id) {
      navigate('/unauthorized');
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    setStatus('');
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
  const res = await fetch(`${process.env.REACT_APP_SERVICE_DOMAIN}/api/feedback`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          user_id: user.id,
          feedback,
        }),
      });
      const data = await res.json();
      if (res.ok && data.success) {
        setStatus('Thank you for your feedback!');
        setFeedback('');
      } else {
        setStatus(data.message || 'Failed to send feedback.');
      }
    } catch {
      setStatus('Failed to send feedback.');
    }
    setSending(false);
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Application Feedback</h2>
      <form onSubmit={handleSubmit} style={styles.form}>
        <label style={styles.label}>Share your thoughts with us</label>
        <textarea
          value={feedback}
          onChange={e => setFeedback(e.target.value)}
          style={styles.textarea}
          rows={6}
          required
        />
        <button
          type="submit"
          style={styles.button}
          disabled={sending}
        >
          {sending ? 'Sending...' : 'Submit'}
        </button>
        {status && <div style={styles.status}>{status}</div>}
      </form>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '600px',
    margin: '40px auto',
    padding: '32px',
    background: '#fff',
    borderRadius: '14px',
    boxShadow: '0 4px 24px rgba(141,110,54,0.10)',
    fontFamily: 'Segoe UI, Arial, sans-serif',
  },
  title: {
    marginBottom: '28px',
    color: '#4078c0',
    fontSize: '1.7rem',
    textAlign: 'center',
    fontWeight: 'bold',
    letterSpacing: '1px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  label: {
    fontWeight: 'bold',
    color: '#8d6e36',
    fontSize: '1.08rem',
    marginBottom: '6px',
  },
  textarea: {
    padding: '10px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '1rem',
    marginBottom: '8px',
    resize: 'vertical',
  },
  button: {
    background: '#388e3c',
    color: '#fff',
    fontWeight: 'bold',
    border: 'none',
    borderRadius: '8px',
    padding: '10px 22px',
    fontSize: '1rem',
    cursor: 'pointer',
    boxShadow: '0 1px 4px #c8e6c9',
    transition: 'background 0.2s',
    marginTop: '8px',
  },
  status: {
    textAlign: 'center',
    color: '#388e3c',
    fontWeight: 'bold',
    marginTop: '8px',
  },
};

export default Feedback;